module.exports = __webpack_public_path__ + "media/images/flags/at-89aa3ac81eab471c825cb6ace94f991b.svg";